import { createContext } from 'react';

type AppContextType = {
  isTelegramBot: boolean;
};

export const AppContext = createContext<AppContextType>({ isTelegramBot: true });
